"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgImpellarFilled(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M25.68 13.31a11.18 11.18 0 01-3.8 3.9A6.06 6.06 0 0120 20.46a9.51 9.51 0 003.18.58c3.07.05 6-2.46 6.66-3A14.86 14.86 0 0030 16a13.89 13.89 0 00-3.06-8.71 11 11 0 01-1.26 6.02zM6.32 18.68a11.18 11.18 0 013.8-3.9A6 6 0 0112 11.54 9.48 9.48 0 008.82 11h-.05c-3.06 0-6 2.46-6.61 3A14.6 14.6 0 002 16a13.89 13.89 0 003.06 8.7 11 11 0 011.26-6.02zM14.12 10.3A6.12 6.12 0 0116 10a6 6 0 011.86.29 9.28 9.28 0 00-1.08-3c-1.53-2.7-5.17-4-6-4.26A14.09 14.09 0 003 10.85 11.12 11.12 0 018.84 9a11.26 11.26 0 015.28 1.3zM18.52 6.27A11.21 11.21 0 0120 11.53a5.93 5.93 0 011.88 3.23A9.58 9.58 0 0024 12.3c1.56-2.66.88-6.44.7-7.28A13.88 13.88 0 0016 2a14.21 14.21 0 00-2.07.17 11.12 11.12 0 014.59 4.1z" }),
        React.createElement("circle", { cx: 16, cy: 16, r: 4 }),
        React.createElement("path", { d: "M13.48 25.72A11.18 11.18 0 0112 20.46a5.94 5.94 0 01-1.88-3.22A9.34 9.34 0 008 19.69c-1.55 2.65-.88 6.44-.7 7.28A13.91 13.91 0 0016 30a14.21 14.21 0 002.07-.17 11.22 11.22 0 01-4.59-4.11zM29 21.12A11.21 11.21 0 0123.23 23h-.07a11.14 11.14 0 01-5.28-1.35A5.84 5.84 0 0116 22a6 6 0 01-1.86-.3 9.41 9.41 0 001.08 3c1.52 2.67 5.17 4 6 4.25A14.08 14.08 0 0029 21.12z" })));
}
exports.default = SvgImpellarFilled;
//# sourceMappingURL=ImpellarFilled.js.map